<div class="relative flex flex-col h-full">
  <div
    #scrollContainer
    class="flex-1 min-h-0 overflow-y-auto scrollbar flex flex-col gap-3 p-3"
    kendoTooltip
    filter="[data-type]"
    [tooltipTemplate]="tooltipTemplate"
    [callout]="false"
  >
    @if (!chatHistory().length && !isLoading()) {
      <div class="flex flex-col items-center justify-center h-full gap-2">
        <img
          [alt]="'outlook.shared.component.noResults' | translate"
          class="w-20"
          [src]="cdn + '/assets/images/empty-container.svg'"
        />
        <p class="text-body text-neutral-70 text-pretty text-center">
          {{ 'outlook.iqBoost.emptyStateChat' | translate }}
        </p>
      </div>
    }

    @for (message of chatHistory(); track $index) {
      @if (message.from === IqChatFrom.User) {
        <div class="flex gap-2 p-3 rounded bg-bush-green-10">
          <span class="avatar avatar-xs avatar-inserv-10 shrink-0">
            {{ userName() | nameInitials }}
          </span>
          <p class="text-body-2 text-neutral-90 min-w-0 break-words">
            {{ message.content }}
          </p>
        </div>
      } @else {
        <div class="flex gap-2 p-1">
          <span
            class="avatar avatar-xs maximizer-icons icon-iq-boost icon-16 shrink-0 bg-inserv-10"
          ></span>
          <div
            class="ai-response text-body-2 text-neutral-90 leading-7 min-w-0 break-words"
            [innerHTML]="
              message.content
                | markdownRendering
                | outlookDeAnonymizer
                | outlookClickableRef
                | outlookEntityKeyRef
                | safeHtml
            "
          ></div>
        </div>
      }
    }

    @if (error()) {
      <div class="flex gap-2 p-1">
        <span
          class="avatar avatar-xs maximizer-icons icon-iq-boost icon-16 shrink-0 bg-inserv-10"
        ></span>
        <div class="flex flex-col gap-2 min-w-0">
          <p class="text-body-2 text-error break-words">
            {{ errorMessage()! | translate }}
          </p>
          @if (canRetry()) {
            <button
              kendoButton
              size="small"
              themeColor="primary"
              class="text-body bold"
              (click)="retry()"
            >
              {{ 'outlook.iqBoost.error.retry' | translate }}
            </button>
          }
        </div>
      </div>
    }
  </div>

  @if (isLoading()) {
    <div
      class="absolute inset-0 flex items-center justify-center bg-white/30 pointer-events-none"
    >
      <maximizer-outlook-iq-boost-loader></maximizer-outlook-iq-boost-loader>
    </div>
  }
</div>

<ng-template #tooltipTemplate let-anchor>
  <p class="caption text-center text-neutral-90 whitespace-nowrap">
    {{ anchor.nativeElement.getAttribute('data-title') }}
  </p>
</ng-template>
